import { FC } from 'react';
import map from 'lodash/map';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import TextArea from 'antd/lib/input/TextArea';
import Select from 'antd/lib/select';
import Space from 'antd/lib/space';
import Switch from 'antd/lib/switch';

import QuestionMark from 'components/QuestionMark/QuestionMark';
import { returnPoliciesFields } from 'components/Settings/fieldsConstants';
import { formRules, questionMarks, textareaWithCounterProps } from 'utils/constants/constants';
import { EPoliciesFields } from 'types/settings/enums';

const { Option } = Select;

const descriptionRules = [
  formRules.required,
  { min: 3, message: 'Must be between 3 and 300 characters' },
  formRules.latinNumberSpecsEnter,
];

const ReturnsPolicy: FC = () => (
  <>
    <h4 className="my-5">Returns Policy</h4>
    <Item>
      <Space align="center">
        <Item name={EPoliciesFields.IsReturnApprove} valuePropName="checked" className="mb-0">
          <Switch className="m-r-5" />
        </Item>
        <div>
          Allow Returns
          <QuestionMark>{questionMarks.policies.allowReturns}</QuestionMark>
        </div>
      </Space>
    </Item>
    <Item shouldUpdate>
      {({ getFieldValue }) => getFieldValue(EPoliciesFields.IsReturnApprove)
        && <Row gutter={20}>
          <Col span={12} key="name">
            {map(returnPoliciesFields, ({ label, name, options, ...item }) =>
              <Item key={name} label={label} name={name} {...item} validateFirst>
                <Select size="large" placeholder={`Enter ${label}`}>
                  {map(options, ({ id, description }) => <Option key={id} value={id}>{description}</Option>)}
                </Select>
              </Item>)}
          </Col>
          <Col span={12}>
            <Item
              validateFirst
              rules={descriptionRules}
              name={EPoliciesFields.ReturnsDescription}
              label="Returns Policy Description"
              tooltip={questionMarks.policies.returnsDescription}
            >
              <TextArea
                placeholder="Enter Returns Policy Description"
                maxLength={300}
                autoSize={{ minRows: 5, maxRows: 5 }}
                {...textareaWithCounterProps}
              />
            </Item>
          </Col>
        </Row>}
    </Item>
  </>);

export default ReturnsPolicy;
